module.exports = __webpack_public_path__ + "a8a10a3e/img/arrow-left-icon.785c715c.svg";